/**
 * Returns true when browser console methods must be disabled.
 * Reads process.env.* directly: Next.js inlines literal process.env tokens at
 * build time, but does NOT substitute aliased reads (e.g. env.NODE_ENV).
 */
export function shouldDisableBrowserConsole(): boolean {
  return (
    process.env.NEXT_PUBLIC_APP_ENV === "production" ||
    process.env.NODE_ENV === "production"
  );
}

/**
 * Patches browser console methods to no-op once.
 */
export function disableBrowserConsole(globalObject: typeof globalThis = globalThis): boolean {
  const markerKey = "__projectXBrowserConsoleDisabled__";
  const marker = globalObject as typeof globalThis & Record<string, unknown>;
  if (marker[markerKey]) {
    return false;
  }

  const noop = () => {};
  globalObject.console.log = noop;
  globalObject.console.info = noop;
  globalObject.console.debug = noop;
  globalObject.console.warn = noop;
  globalObject.console.error = noop;
  marker[markerKey] = true;
  return true;
}

/**
 * Disables browser console methods in production.
 */
export function initializeBrowserConsoleGate(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  if (!shouldDisableBrowserConsole()) {
    return false;
  }
  return disableBrowserConsole();
}
